export const ad1HebTitle = <bdi>חולם על אתר שיקח את העסק שלך צעד קדימה?</bdi>
export const ad1EnTitle = "Dreaming about website that take your business higher?";
export const ad1HebPara = <bdi>תן לי להגשים לך את החלום! - בניית אתרים ועיצוב ברמה הגבוהה ביותר בדגש על שירות איכותי.</bdi>
export const ad1EnPara = "Let me fulfill your dream! - We're create & design sites with emphasis on high service & quailty.";

const en = {
    ad : {
        title : "Dreaming about website that take your business higher?",
        para : "Let me fulfill your dream! - We're create & design sites with emphasis on high service & quailty.",
        btn1 : 'Interested to see works portfolio',
        btn2 : "Click here and we'll talk!",
    },
    about : {
        title : 'A B O U T',
        aboutMe : "Hello , my name Is David Levi , Software & web developer. BSc Computer Science graduate. I have a richable experience in developement world with the newest technologies and the modern design libraries . I invite you to get flexible & accessible service thus we'll create adjusted web for you.",
        whatImDoing : "So what i'm doing actually?",
        slogan : "► In a world of problems ; be the solution ◄",
        body1 : "Increment customer base it's the desire of every business owner , I can make it possible.",
        body2 : "As an owner you can't do that without website.",
        body3 : "If you're in the beginning or you have an experienced , website is important tool in our modern world . Via web you'll keep about your costumers and reach new others.",
        body4 : "What is my advantages ?",
        advantages : ["15 Years of computers knowledege","Use above decade with photoshop & design elements","A richable experience with modren web apps like React & Node.js (ES8)", "Advanced algorithmic thinking ","High social abilties"]    
    },
    contact : {
        title : 'C O N T A C T',
        body : "Leave deatils and we'll get back to you soon or send us message on WhatsApp - we're available :)",
        name : "Name",
        email : "Email",
        phone : "Phone",
        subject : "Subject",
        message : "Message",
        btn : "Send",
        alert1 : "The message send successfuly!",
        alert2 : "There is system error",
        errors : ['Some input is empty','Fix your email address','Fix your phone','Fix your name - only with letters']
    },
    footer : {
        stay : 'Stay connected',
        allRights : "Develop and Design by DAVID LEVI 2021"
    },
    timeline :{
        title : "T I M E L I N E",
        item1 : {
            title :  'David Levi Developer',
            subtitle : "Client & Server side"
        },
        item2 : {
            title :  'FindClass App',
            subtitle : "App for students audience that offer logistic solution of classrooms in colleges",
            era : "April 2019 - July 2019"
        },
        item3 : {
            title :  'BSc Computer Science',
            subtitle : "Holon Institute Technology",
        },
        item4 : {
            title :  'FIFA-IL Site manager & creator',
            dialog : {
                title : "FIFA-IL",
                para : "Site leader and creator in FIFA-IL.com website. I created above 50 patches at that time include IPL'S patches (2009-2012). IPL was patch that added the Israeli Premier League to the famous game FIFA . I worked with graphics files and huge database . It was my amazing success , between 200,000-300,000 downloads to each patch.",
                btn : "Close",
            }
        }
    },
    work : {
        btn1 : "Visit on web",
        btn2 : "I Want"
    },
    works : {
        title : "W O R K S"
    }
}

const heb = {
    ad : {
        title : <bdi>חולם על אתר שיקח את העסק שלך צעד קדימה?</bdi>,
        para : <bdi>תן לי להגשים לך את החלום! - בניית אתרים ועיצוב ברמה הגבוהה ביותר בדגש על שירות איכותי.</bdi>,
        btn1 : <bdi>מעוניין לראות תיק עבודות</bdi>,
        btn2 : <bdi>לחץ כאן ונדבר!</bdi>,
    },
    about : {
        title : <bdi>א ו ד ו ת</bdi>,
        aboutMe : <bdi>שלום , אני דוד לוי , מפתח תוכנה ואתרי אינטרנט. בוגר תואר ראשון במדעי המחשב BSc. ברשותי ניסיון רב בעולמות הפיתוח - בטכנולוגיות החדשניות ביותר ובספריות העיצוב המודרניות . <br></br>אתה מוזמן לקבל ממני שירות נגיש וגמיש כך שנבנה את אתר האינטרנט המותאם עבורך</bdi> ,
        whatImDoing :  <bdi>אז מה אני בעצם עושה?</bdi>,
        slogan : <bdi>► בעולם של בעיות ; תהיה הפתרון ◄</bdi> ,
        body1 : <bdi>להגדיל את קהל הלקוחות זהו רצונו של כל בעל עסק , אני יכול להפוך את זה לאפשרי.</bdi> ,
        body2 : <bdi>כבעל עסק שרוצה לגדול ולהגיע ליותר לקוחות לא תוכל לעשות זאת ללא אתר אינטרנט.</bdi> ,
        body3 : <bdi>אם אתה בתחילת הדרך ובין אם כבר וותיק בתחום , אתר אינטרנט הוא כלי משחק חשוב מאוד בזירה העסקית. באמצעותו תוכל לשמר לקוחות ולמשוך לקוחות חדשים.</bdi> ,
        body4 :  <bdi>מה היתרונות שלי?</bdi>,
        advantages : [<bdi>ניסיון של 15 שנה בעולם המחשבים</bdi>,<bdi>שימוש של למעלה מעשור בפוטושופ ואלמנטים עיצוביים</bdi>,<bdi> ניסיון עשיר בבניית אתרים מודרנית כמו React Node.js (ES8) </bdi>, <bdi>חשיבה אלגוריתמית מתקדמת</bdi>,<bdi>יכולות בינאישיות גבוהות</bdi>]    
    },
    contact : {
        title : <bdi>צ ו ר &nbsp;ק ש ר </bdi>,
        body : <bdi>השאירו פרטים ונחזור אליכם בהקדם או שלחו הודעה בוואטסאפ - אנחנו זמינים :)</bdi>,
        name : "שם",
        email : "מייל",
        phone : "פלאפון",
        subject : "נושא הפנייה",
        message : "תוכן הודעה",
        btn : "שלח",
        alert1 : <bdi>ההודעה נשלחה בהצלחה!</bdi>,
        alert2 : <bdi>ישנה תקלה בשליחת ההודעה</bdi>,
        errors : ['נא למלא את כל הטופס','נא לתקן את כתובת המייל','נא לתקן את מספר הפלאפון','נא לתקן את השם  - רק באותיות']
    },
    footer : {
        stay : 'הישארו מחוברים',
        allRights : "2021 פותח ועוצב על ידי דוד לוי"
    },
    timeline :{
        title : <bdi>צ י ר &nbsp;ז מ ן </bdi>,
        item1 : {
            title :  'דוד לוי מתכנת',
            subtitle : "צד לקוח וצד שרת"
        },
        item2 : {
            title :  <bdi>FindClass אפליקציית</bdi>,
            subtitle : "אפליקציה לקהל הסטודנטים שמהווה פתרון לוגיסטי לכיתות לימוד במכללה",
            era : "אפריל 2019 - יולי 2019"
        },
        item3 : {
            title :  'בוגר תואר ראשון במדעי המחשב',
            subtitle : "HIT המכון הטכנולוגי חולון",
        },
        item4 : {
            title :  'מנהל ויוצר באתר פיפא אי אל',
            dialog : {
                title : "פיפא אי-אל",
                para :"מנהל ויוצר באתר פיפא אי-אל בניתי מעל ל50 פאצ'ים (תוספות למשחק) במהלך התקופה כולל המגה פאץ' - להוספת הליגה הישראלית למשחק הכדורגל המפורסם - פיפ''א . עבדתי בעיקר עם מסדי נתונים ענקיים וקבצי גרפיקה והתאמתם לזירה המקומית . הפאצ'ים זכו להצלחה אדירה של 200,000-300,000 הורדות בכל שנה",
                btn : "סגור",
            }
        }
    },
    work : {
        btn1 : "בקר באתר",
        btn2 : "אני רוצה"
    },
    works : {
        title : <bdi>ת י ק &nbsp;ע ב ו ד ו ת</bdi>
    }
}

export default {
    en : en , 
    heb : heb
};